import { Observable } from 'rxjs';

export abstract class GgInStockReminderAdapter {
  abstract remindUser(productCode: string, email: string, subscriptions: string[]);
}
